import "./index.css";
import "./react-vis-style.css";

import React from "react";
import ReactDOM from "react-dom";
import registerServiceWorker from "./registerServiceWorker";
import { Provider } from "react-redux";
import store from "./store";
import ThemedAppContainer from "./ThemedAppContainer";
import { fetchPrereqs } from "./actions/prerequisites";

store.dispatch(fetchPrereqs());

ReactDOM.render(
  <Provider store={store}>
    <ThemedAppContainer />
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js